/**
 * ======================================
 * Mutation types for the auth module
 * ======================================
 *
 * The mutation types that are available
 * on the auth module.
 */

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const UPDATE_USER = 'UPDATE_USER';
export const GET_USERS = 'GET_USERS';
export const SET_USER_GUIDE = 'SET_USER_GUIDE';

export default {
  LOGIN,
  LOGOUT,
  UPDATE_USER,
  GET_USERS,
  SET_USER_GUIDE,
};
